import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fpf4yb7vsz: FaireBrandEntity = {
  token: "b_fpf4yb7vsz",
  type: "brand",
  name: "KMB Shoes",
  avatarUrl: "https://cdn.faire.com/fastly/afd9b11c7fb0c6ff15abfb194ca55e567935e06b6c22a586617d6b3edd4118a2.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/0c47588d6d04a876d78289fba18208205d1ecba537f81ffea475affeb57314ab.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/afd9b11c7fb0c6ff15abfb194ca55e567935e06b6c22a586617d6b3edd4118a2.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/0c47588d6d04a876d78289fba18208205d1ecba537f81ffea475affeb57314ab.jpeg",
  location: "ESP",
  minimumOrderDollars: 117,
  rating: 4.9,
  reviewCount: 31,
  isTopShop: true,
  isInsider: false,
  description: "The know-how of several generations of shoemakers is now translated into a brand with more than forty years of experience, made up of a solid team of professionals who put all their passion and efforts into making and delivering to everyone a product made in Spain that combines quality and comfort.\n\nMaterials and lasts adapted to different styles that result in shoes with the latest trends. The versatility of the collections makes them suitable for any type of woman.\n\nKMB seeks to dress the woman who lives as she feels.\n\nEach design has a work and craftsmanship process behind where we put a huge dedication in each stage of creation. We like to do things well, working with the best quality to offer you the best service. We adapt to fashions and trends but always without losing our own essence.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:04.810Z",
    importedBy: "entity-db-cli"
  }
};
